import { execOnLoad } from '../../scripts/helpers';
import './editorial-gallery.scss';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initEditorialGallery = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const swiper = sectionContainer.querySelector('.swiper');
  if (!swiper) return;

  new Swiper(swiper, {
    slidesPerView: 'auto',
    spaceBetween: 40,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
    breakpoints: {
      1025: {
        spaceBetween: 160,
        slidesOffsetBefore: 48,
        slidesOffsetAfter: 48,
      },
    },
    modules: [Navigation],
    navigation: {
      prevEl: sectionContainer.querySelector(
        '.editorial-gallery__navigation-prev',
      ),
      nextEl: sectionContainer.querySelector(
        '.editorial-gallery__navigation-next',
      ),
    },
  });
};

execOnLoad(window.dAgency.initEditorialGallery, '.editorial-gallery__section');
